import React, { useContext } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { emailFormFields, emailSchema, EmailType } from '@Entities/schemas/user/forgot-password'
import { zodResolver } from '@hookform/resolvers/zod'
import FormFieldFromProps from '@App/kit/fields/v2/FormFieldFromProps'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

interface CollectEmailStepProps {
    setEmailAddress: (email: string) => void
}

const CollectEmailStep = (props: CollectEmailStepProps) => {
    const { authStore, preloaderStore } = useContext<RootStore>(StoresContext)

    const { setEmailAddress } = props

    const onSubmit = async (data: EmailType) => {
        preloaderStore.openTransparentPreloader(true)
        const username = data.username
        await authStore.forgotPassword(username)
        setEmailAddress(username)
        preloaderStore.openTransparentPreloader(false)
    }

    const methods = useForm<EmailType>({
        mode: 'onChange',
        criteriaMode: 'all',
        delayError: 750, // MilliSeconds: this delay is here so email validation doesn't start when user starts typing
        resolver: zodResolver(emailSchema),
    })

    return (
        <>
            <h3 className="with-subtitle">Forgot password</h3>
            <div className="subtitle">Enter the email address associated with your account.</div>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                    <FormFieldFromProps field={emailFormFields.username} />
                    <Button
                        mainColor
                        type="primary"
                        icon={ICONS.arrow_forward}
                        submitType="submit"
                        disabled={!methods.formState.isValid}
                    >
                        Send Recovery Code
                    </Button>
                </form>
            </FormProvider>
        </>
    )
}

export default observer(CollectEmailStep)
